/**
 * cb.core.utils Module
 * by Lev K. College Board 2013
 */

import log4javascript, {Level} from 'log4javascript/js/log4javascript_production.js';
import BrowserConsoleAppender from './BrowserConsoleAppender';
import {get} from 'lodash-es'

/**
 * cb core Utils Module
 */

  // Get the deployment profile (if present), api key from it, and executing env mode
  let _DeploymentProfile = get(window, 'cb.core.utils.DeploymentProfile', {});
  let _apiKey            = _DeploymentProfile.apiKey || 'generic';
  export let isDebugMode        = /debug/i.test(_DeploymentProfile.mode);

    // levity 1.2.*: adds support for the stock log4javascript_production.js
    // which is 2.5 times smaller in size than the full version
      log4javascript.BrowserConsoleAppender = BrowserConsoleAppender;

    // configure root logger (it will be inherited by all the loggers)
    var consoleAppender = new log4javascript.BrowserConsoleAppender();
    var layout = new log4javascript.PatternLayout('%d{HH:mm:ss,SSS} %c %-5p - %m');
    consoleAppender.setLayout(layout);

    var rootLogger = log4javascript.getRootLogger();
    rootLogger.removeAllAppenders();
    rootLogger.addAppender(consoleAppender);

    // set default loglevel
    rootLogger.setLevel( isDebugMode ? log4javascript.Level.DEBUG :
                                       log4javascript.Level.INFO);

  //---------------------------------------------------------------------------
  function _setAPIKey(apiKey) {

    _apiKey = apiKey;
  }

  //---------------------------------------------------------------------------
  function _getAPIKey() {

    return _apiKey;
  }

  /**
   * cb core utils module public API
   */

  export default {

    /**
     * @name cb.core.utils.getAPIKey
     * @description returns current app api key
     */
    getAPIKey : _getAPIKey,

    /**
     * @name cb.core.utils.setAPIKey
     * @description sets current app api key
     * @param {String} api key
     */
    setAPIKey : _setAPIKey,

    /**
     * Logger is an adapter on top of a pluggable logging provider
     * similar to commons logging in java
     */
    Logger : log4javascript,

    /**
     * Deployment profile for levity
     */
    DeploymentProfile : _DeploymentProfile

  };
